import { render, staticRenderFns } from "./tabbar.vue?vue&type=template&id=8a298450&scoped=true&"
import script from "./tabbar.vue?vue&type=script&lang=js&"
export * from "./tabbar.vue?vue&type=script&lang=js&"
import style0 from "./tabbar.vue?vue&type=style&index=0&id=8a298450&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a298450",
  null
  
)

export default component.exports